import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.handleClick = this.handleClick.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.element.addEventListener("click", this.handleClick)
    this.element.addEventListener("change", this.handleChange)
    this.syncSelected()
  }

  disconnect() {
    this.element.removeEventListener("click", this.handleClick)
    this.element.removeEventListener("change", this.handleChange)
  }

  handleClick(event) {
    const card = event.target.closest(".slot-radio-option")
    if (!card || !this.element.contains(card)) return
    if (card.classList.contains("disabled")) return
    const radio = card.querySelector('input[type="radio"]')
    if (!radio || radio.disabled) return
    if (!radio.checked) {
      radio.checked = true
      radio.dispatchEvent(new Event("change", { bubbles: true }))
    }
    this.updateSelected(card)
  }

  handleChange(event) {
    if (!event.target.matches('input[type="radio"]')) return
    const card = event.target.closest(".slot-radio-option")
    if (!card) return
    this.updateSelected(card)
  }

  updateSelected(card) {
    this.element
      .querySelectorAll(".slot-radio-option.selected")
      .forEach((opt) => opt.classList.remove("selected"))
    card.classList.add("selected")
    this.updateTotal(card)
  }

  syncSelected() {
    const checked = this.element.querySelector(
      '.slot-radio-option input[type="radio"]:checked'
    )
    if (!checked) return
    const card = checked.closest(".slot-radio-option")
    if (!card) return
    this.updateSelected(card)
  }

  // Write the selected slot's price into the "Total Due Today" element.
  // The price lives in data-slot-price (raw integer) on the card; the
  // total node is [data-ads-total] elsewhere in the document.
  updateTotal(card) {
    const price = parseInt(card.dataset.slotPrice, 10)
    if (Number.isNaN(price)) return
    const totalEl = document.querySelector("[data-ads-total]")
    if (!totalEl) return
    const formatted = price.toLocaleString("en-US")
    totalEl.innerHTML =
      "$" + formatted +
      '<span class="text-body-md text-on-surface-variant">.00</span>'
  }
}
